/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorMedicineMaterialsAliases {
  BUTTON_SELECT = 'button-select',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_MATERIAL_LOCATOR = 'fetch-material-locator',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FILTER_MEDICINE_MATERIALS = 'filter-medicine-materials',
  FILTERED_LIST_0 = 'filtered-list-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  LOADER = 'loader',
  PAGINATOR = 'paginator',
  PANEL = 'panel',
  PANEL_FILTER = 'panel-filter',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  PANEL_LOADER = 'panel-loader',
  PANEL_LOCATOR_MEDICINE_MATERIALS = 'panel-locator-medicine-materials',
  PANEL_MESSAGE = 'panel-message',
  PANEL_PAGINATOR = 'panel-paginator',
  TABLE_COLUMN_0 = 'table-column-0',
  TABLE_COLUMN_1 = 'table-column-1',
  TABLE_MATERIALS = 'table-materials',
  TEXT_MESSAGE = 'text-message',
}
export { LocatorMedicineMaterialsAliases };
